/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import MultiRangeSlider from './components/range-selector';
import { IToysrusGiftfinderArViewProps } from './toysrus-giftfinder-ar';

export default (props: IToysrusGiftfinderArViewProps) => {
    return (
        <>
            <div className="giftfinder-header"></div>
            <div className="giftfinder-header-text">ابحث عن الهدية المناسبة</div>
            <div className="gift-finder-body">
            {
props.isGenderSelected 
?



                props.isAgeSelected 
                ?
                <div className="gift-finder-budgetcontainer" id="gift-finder-budgetcontainer">
                    <div className="giftfinder-lable"> ماهي القيمة الأنسب لك؟</div>
                    <div className="giftfinder-currency dirleft">
                        <output id="num">{props.budgetAmountMin} - {props.budgetAmountMax}</output>
                        <span>  ريال</span>
                    </div>
                    <br/>
                    <br/>
                    <MultiRangeSlider
                        min={1}
                        max={5001}
                        maxValue={props.budgetAmountMax}
                        minValue={props.budgetAmountMin}
                        stepVal={50} 
                        onChange={({ min, max }) => {
                            props.onBudgetAmountMaxInput(max);
                            props.onBudgetAmountMinInput(min);
                            console.log(`min = ${min}, max = ${max}`)
                        }}
                    />
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                    <button onClick={props.getGiftSuggestions} type="button" className="giftfinder-button gift-finder-green-button">أحصل على إقتراحات للهدايا</button>
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                    <button onClick={props.giftfinderBack} type="button" className="giftfinder-button">العودة</button>
                </div>
                :
                <div className="Giftfinder-agecontainer"  id="Giftfinder-agecontainer">
                    <br/>
                    <br/>
                    <div className="giftfinder-lable">اختر العمر</div>
                    <br/>
                    <br/>
                    {
                        props.ageGroups && props.ageGroups.map( ag => (
                            <div className={ag.containerClassName}>
                            <label className="gift-finder-container">{ag.ageLabel}
                                <input name="color" type="checkbox" value={ag.ageValue} id={ag.id} checked={ag.isChecked} onChange={props.onAgeInput}/>
                                <span className="gift-finder-checkmark"></span>
                            </label>
                            </div>
                        ))
                    }
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                    <div className="toysfinder-btn-col">
                    <button onClick={props.giftfinderNext} type="button" className="giftfinder-button">التالي</button>
                    <button onClick={props.giftfinderBack1} type="button" className="giftfinder-button giftfinder-back1">العودة</button>
                   
                    </div>
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                </div>
:
<div className="eidbox-agecontainer"  id="Giftfinder-agecontainer">
    <br/>
    <br/>
    <div className="giftfinder-lable">حدد نوع الجنس</div>
    <br/>
    <br/>
    {
        props.genderGroups && props.genderGroups.map( gd => (
            <div className={gd.containerClassName}>
            <label className="gift-finder-container">{gd.genderLabel}
                <input name="gender" type="radio" value={gd.genderValue} id={gd.id} checked={gd.isChecked} onChange={props.onGenderInput}/>
                <span className="gift-finder-checkmark"></span>
            </label>
            </div>
        ))
    }
    <br/>
    <br className="clr-bth"/>
    <br/>
    <div className="toysfinder-btn-col">
        <button onClick={props.giftfinderNext1} type="button" className="giftfinder-button">التالي</button>
    </div>
    <br/>
    <br className="clr-bth"/>
    <br/>
</div>
}  
            </div>
        </>
    );
};
